export default "__VITE_ASSET__d435af01__"